import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { MemberStateTaxes, StateTaxExtended, StateTaxIndexModel } from "src/app/models/taxes";
import { PayrollService } from "src/app/services/payroll.service";
import { ChangeRequestStateTax } from "src/app/models/change-requests";
import { ChangeRequestStatus } from "src/app/constants/change-request";

@Component({
    selector: 'mwp-state-tax',
    templateUrl: './state-tax.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PayrollStateTaxTableComponent implements OnInit {
    public apiUrl = ContentHeaderKey.PayrollStateTaxDetails;

    public memberStateTaxes: MemberStateTaxes;
    public stateTax: StateTaxExtended[];
    public displayStateTaxForm: boolean;
    public currentStateTax: StateTaxExtended;
    public currentStateIndex: StateTaxIndexModel;
    public currentChangeRequestStateTax: ChangeRequestStateTax;
    public changeRequestFormModel: ChangeRequestStateTax;

    public isEditing: boolean;
    public pendingOrDeniedHeader: string;
    public buttonText: string;
    public displayTopRequestButton: boolean;
    public displayPendingOrDeniedRequest: boolean;

    public payload: ChangeRequestStateTax;
    
    constructor(
        private payrollService: PayrollService,
    ) {
    }

    ngOnInit(): void {
        this.payrollService.getStateTaxes().subscribe((response: MemberStateTaxes) => {
            this.memberStateTaxes = response;
            this.currentStateIndex = this.memberStateTaxes.stateTaxIndexModels[0];
            this.setSelectedState();
        });
        this.buttonText = 'REQUEST TO CHANGE STATE TAX INFORMATION';
    }

    public loadStateTaxes(): void {
        this.payrollService.getStateTaxes().subscribe((response: MemberStateTaxes) => {
            this.memberStateTaxes = response;
            this.currentStateIndex = this.memberStateTaxes.stateTaxIndexModels[0];
            this.setSelectedState();
        });
    }

    public changeStateSelection(stateTaxIndex: StateTaxIndexModel): void {
        this.currentStateIndex = stateTaxIndex;
        this.setSelectedState();
    }
    
    public newChangeRequest() {
        this.changeRequestFormModel = new ChangeRequestStateTax();
        if (this.currentStateTax) {
            this.changeRequestFormModel.state = this.currentStateTax.state;
            this.changeRequestFormModel.stateTaxDetail = this.currentStateTax.stateTaxDetail;
            this.changeRequestFormModel.stateTaxRequiredFields = this.currentStateTax.stateTaxRequiredFields;

            // Reset Specific Control
            this.changeRequestFormModel.isUniversalControl = this.currentStateTax.isUniversalControl;
            this.changeRequestFormModel.isArizonaControl = this.currentStateTax.isArizonaControl;
            this.changeRequestFormModel.isNewYorkControl = this.currentStateTax.isNewYorkControl;
            this.changeRequestFormModel.isPuertoRicoControl = this.currentStateTax.isPuertoRicoControl;
            this.changeRequestFormModel.noStateTax = this.currentStateTax.noStateTax;
            this.changeRequestFormModel.stateTaxDetail.exemptStateTaxExemptFieldValue = 0;
            this.changeRequestFormModel.stateTaxDetail.azCheckbox1 = false;
            this.changeRequestFormModel.stateTaxDetail.azCheckbox2 = false;
            this.changeRequestFormModel.stateTaxDetail.azCheckboxExtraWithholding = false;
        }
        this.isEditing = true;
    }

    public editChangeRequest() {
        this.changeRequestFormModel = this.currentChangeRequestStateTax;
        this.isEditing = true;
    }

    public cancelEdit(event: ChangeRequestStateTax) {
        if (event)
            this.payrollService.getStateTaxes().subscribe((response: MemberStateTaxes) => {
                this.memberStateTaxes = response;
                this.memberStateTaxes.stateTaxIndexModels.forEach((stim: StateTaxIndexModel) => {
                    if(stim.code == event.state)
                        this.currentStateIndex = stim;
                });
                this.setSelectedState();
                this.isEditing = false;
            });
        else
            this.isEditing = false;
    }

    private setSelectedState(): void {
        this.displayStateTaxForm = false;
        this.currentStateTax = null;
        this.memberStateTaxes.stateTaxModels.forEach(stm => {
            if (stm.state == this.currentStateIndex.code) {
                this.currentStateTax = stm;

                this.currentChangeRequestStateTax = null;
                if (this.memberStateTaxes.changeRequestStateTaxModels)
                    this.memberStateTaxes.changeRequestStateTaxModels.forEach((srstm: ChangeRequestStateTax) => {
                        if (srstm.state == stm.state)
                            this.currentChangeRequestStateTax = srstm;
                    });
                this.buildCurrentChangeRequest(this.currentChangeRequestStateTax??  new ChangeRequestStateTax());
            }
                
        });
        this.displayStateTaxForm = true;
    }

    private buildCurrentChangeRequest(changeRequest: ChangeRequestStateTax): void {
        this.displayPendingOrDeniedRequest = false
        this.displayTopRequestButton = true;
        this.pendingOrDeniedHeader = null;
        this.buttonText = "REQUEST TO CHANGE STATE TAX";
        if (changeRequest.id > 0)
            this.currentChangeRequestStateTax = changeRequest;

        switch(changeRequest.changeRequestStatusID) {
            case ChangeRequestStatus.submitted:
                this.pendingOrDeniedHeader = "Submitted State Tax Change Request";
                this.buttonText = "UPDATE STATE TAX CHANGE REQUEST";
                this.displayPendingOrDeniedRequest = true;
                break;

            case ChangeRequestStatus.denied:
                this.displayTopRequestButton = false;
                this.pendingOrDeniedHeader = "Denied State Tax Change Request";
                this.displayPendingOrDeniedRequest = true;
                break;

            default:
                break;
        }   
    }

}

